"use client"

import { useRouter } from "next/navigation"
import type React from "react"
import { revalidateUserTag } from "utils/handlers/revalidateUserTag"

import { Button, Icon } from "@chakra-ui/react"
import { SignOutButton as ClerkSignOutButton, useAuth } from "@clerk/nextjs"
import { LogoutIcon } from "@heroicons/react/outline"

const SignOutButton: React.FC = () => {
    const { signOut } = useAuth()

    const router = useRouter()

    const handleClick = async () => {
        try {
            await revalidateUserTag()
            await signOut(
                async () => {
                    router.push("/login")
                    // Removing datadog implementation due to CORs errors
                    // datadogRum.clearUser()

                    // @ts-ignore
                    // window.dataLayer.push(() => this.reset())
                    // router.refresh()
                }
                // { sessionId }
            )
            // await revalidateUserTag()
            // await logOut()
            // router.push('/login')
        } catch (error) {
            console.error("There was an issue with the signout action", error)
        }
    }
    return (
        <ClerkSignOutButton redirectUrl='/login'>
            <Button
                variant='nude'
                size='sm'
                className='w-full flex-row items-center justify-start border-0 px-4 py-2.5 text-left text-red-500 hover:bg-gray-100 xl:flex-row xl:justify-start dark:text-red-400 dark:hover:bg-gray-500'
                leftIcon={<Icon as={LogoutIcon} className='text-xl' />}
            >
                Sign Out
            </Button>
        </ClerkSignOutButton>
    )
}

export default SignOutButton
